import { render, staticRenderFns } from "./BuildingDistanceMaintenance.vue?vue&type=template&id=9965dcd2&scoped=true"
import script from "./BuildingDistanceMaintenance.vue?vue&type=script&lang=js"
export * from "./BuildingDistanceMaintenance.vue?vue&type=script&lang=js"
import style0 from "./BuildingDistanceMaintenance.vue?vue&type=style&index=0&id=9965dcd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9965dcd2",
  null
  
)

export default component.exports